export const NEW_THREAD = 'NEW_THREAD'
export const NEW_MESSAGE = 'NEW_MESSAGE'
export const CLEAR_THREAD = 'CLEAR_THREAD'



// WEBPACK FOOTER //
// ./src/common/store/Chat/types.js